<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-6 lg:px-0 py-11 lg:pb-12 lg:pt-14 col-span-full md:col-start-2 lg:col-start-2 md:col-end-8 lg:col-end-12"
    >
      <section class="max-w-187.5 text-center text-lg pb-9 lg:pb-15">
        <p
          class="text-3xl font-bold"
          v-text="'Lorem ipsum dolor sit amet consectetur adipiscing elit'"
        />
        <p class="pt-6 font-medium" v-text="'Lorem ipsum dolor sit amet consectetur adipiscing elit'"/>
        <p
          class="pt-6"
          v-text="
            `Lorem Ipsum is simply dummy textof the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five.`
          "
        />
      </section>
      <section class="border border-black rounded-xl px-20-px pb-20-px lg:p-9">
        <section class="flex justify-center -mt-6 lg:-mt-15">
          <p
            class="text-lg py-2.5 lg:px-3 text-center w-40 bg-white"
            v-text="'Regístrate Gratis'"
          />
        </section>
        <section class="grid lg:grid-cols-3 gap-x-12 gap-y-2.5 pt-7 lg:pt-3.5">
          <section class="flex flex-col gap-y-2.5 lg:gap-y-6">
            <input-field
              identity="firstName"
              ref="firstName"
              placeholder="Nombre"
              v-model="contactData.firstName"
              :rules="{
                required: true,
              }"
            />
            <input-field
              identity="lastName"
              ref="lastName"
              placeholder="Apellidos"
              v-model="contactData.lastName"
              :rules="{
                required: true,
              }"
            />
          </section>
          <section class="flex flex-col gap-y-2.5 lg:gap-y-6">
            <input-field
              identity="email"
              ref="email"
              placeholder="Correo electrónico"
              v-model="contactData.email"
              :rules="{
                required: true,
                email: true,
              }"
            />
            <input-field
              identity="phone"
              ref="phone"
              placeholder="Teléfono"
              v-model="contactData.phone"
              :rules="{
                required: true,
                numeric: true,
              }"
            />
          </section>
          <section class="flex flex-col gap-y-2.5 lg:gap-y-9">
            <main-button class="lg:w-full" />
            <p
              class="text-sm h-full"
              v-text="
                'Lorem Ipsum is simply dummy text of the printing and types etting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s'
              "
            />
          </section>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
export default {
  components: {
    InputField: () => import("../components/InputField.vue"),
    MainButton: () => import("../components/MainButton.vue"),
  },
  data: () => ({
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
    },
  }),
  props: {
    withBorder: {
      default: true,
    },
  },
};
</script>
